module.exports = __webpack_public_path__ + "img/lupa_azul.85eaaaf8.svg";